<div class="step-five">

    <app-country-selector [form]="form.get('locationPreferences')"
        *ngIf="form.get('studyPreferences.studyInterest').value === 'El exterior'"></app-country-selector>

    <app-colombia-selector [form]="form.get('locationPreferences')"
        *ngIf="form.get('studyPreferences.studyInterest').value === 'Mi pais'  || form.get('studyPreferences.studyInterest').value === 'Aun no lo se' "></app-colombia-selector>


</div>